import { ParameterValue, RouteName, RouteParams } from "ziggy-js";

export function relativeRoute<T extends RouteName>(
  name: T,
  params?: RouteParams<T> | ParameterValue | undefined,
): string {

  // const page = usePage()
  // console.log(page)

  // const useNewBestelstraat = page.props.bestelstraat ?? false
  // const win = window as StorybookWindow
  // if (win.IS_STORYBOOK){
  //   return 'dummy-route';
  // }
  // if (name === 'order' && !useNewBestelstraat) {
  //
  // }

  if (typeof route === 'undefined') {
    return '#'
  }
  // @ts-ignore
  return route(name, params, false)
}


